import { IReward } from "api/types";
import Text from "components/common/Text/Text";
import * as React from "react";
import { Col, Row } from "react-grid-system";
import styled from "styled-components";
import theme from "themes/simple-theme";

export interface ICartReward extends IReward {
  reward: IReward;
  className?: string;
  tenantId?: string;
  locationId?: string;
  rewardImageBaseUrl?: string;
  transparentBackground?: boolean;
  removeFromCart?(reward: IReward): void;
}

const CartReward = styled(
  ({
    reward,
    className,
    removeFromCart,
    tenantId,
    locationId,
    rewardImageBaseUrl,
    transparentBackground
  }: ICartReward) => {
    const onClick = () => (removeFromCart ? removeFromCart(reward) : null);
    const {
      id,
      imageId,
      defaultImage,
      name,
      pointsRequired,
      quantity = 0
    } = reward;
    const imageUrl = imageId !== "" ? `${imageId}` : defaultImage;
    return (
      <Row
        id={id}
        align="center"
        justify="between"
        nogutter
        className={className}
      >
        <Col style={{ paddingLeft: "10px" }} xs={2}>
          <img src={imageUrl} />
        </Col>
        <Col xs={5} align="start">
          <Name transparentBackground={transparentBackground}>{name}</Name>
        </Col>
        <Col>
          <Text bold small>
            x {quantity}
          </Text>
        </Col>
        <Col xs={4} align="end">
          <Points>{pointsRequired} Points</Points>
        </Col>
        {removeFromCart && (
          <Col xs={12}>
            <RemoveLink id={`remove-reward-${id}`} onClick={onClick}>
              Remove
            </RemoveLink>
          </Col>
        )}
      </Row>
    );
  }
)`
  ${({ transparentBackground }: ICartReward) => `
  padding: 1.5rem 0;
  text-transform: uppercase;
  font-size: 1.35rem;
  width: 100%;
  background-color: ${
    transparentBackground ? "transparent" : theme.color.secondary
  };
  color: ${theme.color.primary};
  font-family: ${theme.fontFamily.bold};
  border-bottom: 1px solid ${theme.color.primary};
  img {
    max-width: 100%;
    max-height: 50px;
    margin-left: auto;
    margin-right: auto;
    display: inline-block;
  }`};
`;

interface INameProps {
  transparentBackground?: boolean;
}

const Name = styled.span`
  padding-left: 10px;
  color: ${theme.color.primary};
  background-color: ${({ transparentBackground }: INameProps) =>
    transparentBackground ? "transparent" : theme.color.secondary};
`;

const Points = styled.span`
  margin-right: 25px;
  float: right;
  color: ${theme.color.primary};
`;

const RemoveLink = styled.div`
  float: right;
  font-size: 12px;
  padding: 10px 10px 0 0;
  margin-right: 15px;
  text-transform: uppercase;
  cursor: pointer;
  color: ${theme.color.primary};
  font-family: ${theme.fontFamily.bold};
`;

export default CartReward;



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/ChooseRewards/Cart/CartReward.tsx